import React from "react";
import "../styles/Portfolio.css";
import Lunar from "../assets/Lunar.svg";
import Nourish from "../assets/Nourish.svg";

function WorkPortfolio() {
  return (
    <section id="projects">
      <div className="portfolio-section">
        <h2>Projects</h2>
        <div className="portfolio-items">
          <div className="portfolio-item">
            <a
              href="https://hci.stanford.edu/courses/cs147/2024/au/projects/Design-for-Healthy-Behaviors/Lunar/"
              target="_blank"
              rel="noopener noreferrer"
              className="project-link"
            >
              <img src={Lunar} alt="Lunar" class="project" />
            </a>
            <div className="project-text">
              <p class="project-name">Lunar</p>
              <d class="project-description">
                {" "}
                A mobile app for night-shift workers to find support and
                tailored resources to their unique challenges.
              </d>
            </div>
          </div>
          <div className="portfolio-item">
            <a
              href="https://github.com/CS342Industry/2024-Nourish"
              target="_blank"
              rel="noopener noreferrer"
              className="project-link"
            >
              <img src={Nourish} alt="Nourish" class="project" />
            </a>
            <div className="project-text">
              <p class="project-name">Nourish Navigator </p>
              <d class="project-description">
                Allowing ED patients to intuitively track caloric intake goals.
                Deployed in Lucille Packard Children's Hospital.
              </d>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WorkPortfolio;
